<template>
	<div class="news-wrapper is-marged-bottom">
		<div class="notification is-warning" v-for="newsObject in news">
			<h3 class="title is-h3">{{ newsObject.title }}</h3>
			<div v-html="newsObject.copy"></div>
		</div>
	</div>
</template>

<script>
	import {ApiMonizze} from '../api-monizze';

	export default {
		props: {
			url: String
		},
		data ()
		{
			return {
				news: [],
			};
		},
		mounted ()
		{
			const api = new ApiMonizze();
			api.getDataFromApi(
				this.url,
				(data, response) =>
				{
					this.news = response
				}
			);
		}
	}
</script>

<style scoped>

</style>
